module.exports = __webpack_public_path__ + "img/zngzh.fd5fbd2e.jpg";